// src/utils/money.ts

/**
 * Shared USD currency formatter.
 * - Fixed to 2 decimal places
 * - Uses US locale for consistent separators
 */
const USD_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Format a number into a human-readable USD string.
 *
 * Examples:
 *   15        -> "USD 15.00"
 *   -15       -> "- USD 15.00"
 *   0         -> "USD 0.00"
 *
 * Note:
 * Intl default output is "$15.00".
 * We intentionally replace "$" with "USD" for clarity and consistency
 * across admin UIs.
 */
export const toUsdDisplay = (amount: number): string => {
  if (!Number.isFinite(amount)) {
    return 'USD 0.00';
  }

  const absFormatted = USD_FORMATTER
    .format(Math.abs(amount))
    .replace('$', 'USD ');

  return amount < 0 ? `- ${absFormatted}` : absFormatted;
};
